<script lang="ts" setup>
import { Employee } from './EmployeeSingle.vue'
defineProps<{
  employees: Employee[]
}>()
</script>
<template>
  <ul class="list cul">
    <li v-for="employee in employees" :key="employee.id" v-animate="{ animation: 'vertical-reveal' }">
      <EmployeeTeaser :data="employee" />
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.list {
  display: grid;
  grid-template-columns: 100%;
  gap: var(--gap);
  @include breakpoint(t) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @include breakpoint(ds) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
